import { action } from 'typesafe-actions';
import {
  COMPETITIONS_FAILURE,
  COMPETITIONS_REQUEST,
  COMPETITIONS_SUCCESS,
} from '../../constants/competitions';

export const competitionsRequestAction = (competition_id?: string) =>
  action(COMPETITIONS_REQUEST, competition_id);
export const competitionsSuccessAction = (data: any) =>
  action(COMPETITIONS_SUCCESS, data.competition);
export const competitionsFailureAction = (e: any) =>
  action(COMPETITIONS_FAILURE, e);

export const competitionsActions = {
  competitionsRequestAction,
  competitionsSuccessAction,
  competitionsFailureAction,
};
